module.exports = __webpack_public_path__ + "static/media/Leonardo-Dicaprio-Cheers.e0f9cfbd.jpg";